import React, { useRef } from 'react';
import { UploadButtonProps } from '../../../types';
import Button from '../../atoms/Button';
import './UploadButton.css';

const UploadButton: React.FC<UploadButtonProps> = ({
  onChange,
  multiple = false,
  accept = 'image/*',
  className = '',
  children
}) => {
  const fileInputRef = useRef<HTMLInputElement>(null);

  const handleClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  return (
    <div className={`upload-button-container ${className}`.trim()}>
      <Button 
        variant="secondary" 
        onClick={handleClick} 
        className="upload-button"
      >
        {children}
      </Button>
      <input
        type="file"
        ref={fileInputRef}
        onChange={onChange}
        multiple={multiple}
        accept={accept}
        className="upload-input"
      />
    </div>
  );
};

export default UploadButton;
